// Firebase-synced shared state besides the restaurant list: profile photos, the active check game, the planned date.
// Each path has its own listener (db.subscribe), attached once auth is ready and never leaked on unmount.
import { useState, useEffect } from 'react';
import { subscribe } from '../db.js';

const NO_PHOTOS = { doug: null, les: null };

function readJSON(key, fallback) {
    try {
        const v = JSON.parse(localStorage.getItem(key) || 'null');
        return v ?? fallback;
    } catch {
        return fallback;
    }
}

export function useSharedState({ enabled }) {
    const [profilePhotos, setProfilePhotos] = useState(() => readJSON('profilePhotos', NO_PHOTOS));
    const [activeGame, setActiveGame] = useState(null);
    const [myGuess, setMyGuess] = useState('');
    const [actualAmount, setActualAmount] = useState('');
    const [resultCountdown, setResultCountdown] = useState(null);
    const [plannedDate, setPlannedDate] = useState(() => readJSON('plannedDate', null));

    useEffect(() => {
        if (!enabled) return undefined;
        const offPhotos = subscribe('profilePhotos', (photos) => {
            const value = { ...NO_PHOTOS, ...(photos || {}) }; // a removed last photo arrives as null: clear it here too
            setProfilePhotos(value);
            try { localStorage.setItem('profilePhotos', JSON.stringify(value)); } catch { /* quota */ }
        });
        const offGame = subscribe('activeGame', (game) => {
            setActiveGame(game || null);
            if (!game) {
                setMyGuess('');
                setActualAmount('');
                setResultCountdown(null);
            }
        });
        const offPlan = subscribe('plannedDate', (data) => {
            setPlannedDate(data || null);
            try {
                if (data) localStorage.setItem('plannedDate', JSON.stringify(data));
                else localStorage.removeItem('plannedDate');
            } catch { /* quota */ }
        });
        return () => { offPhotos(); offGame(); offPlan(); };
    }, [enabled]);

    return {
        profilePhotos, setProfilePhotos,
        activeGame, setActiveGame,
        myGuess, setMyGuess,
        actualAmount, setActualAmount,
        resultCountdown, setResultCountdown,
        plannedDate, setPlannedDate,
    };
}
